// ============= Imports =============
import React, { useState } from 'react';
import { Button } from '@/ui';
import { VISUAL_PROMPT_MESSAGES } from '@/constants/visualPrompts/messages';
import { Collapse, PreviewBox, Wrapper } from './styles';

export interface VisualPromptPreviewProps {
  compiledPreview: string;
}

// ============= Component =============
export const VisualPromptPreview: React.FC<VisualPromptPreviewProps> = ({
  compiledPreview,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Wrapper>
      <Button variant="secondary" onClick={() => setOpen((v) => !v)}>
        {open
          ? VISUAL_PROMPT_MESSAGES.previewToggleHide
          : VISUAL_PROMPT_MESSAGES.previewToggleShow}
      </Button>
      {open && (
        <Collapse>
          <strong>{VISUAL_PROMPT_MESSAGES.previewTitle}</strong>
          <PreviewBox>{compiledPreview || '(empty)'}</PreviewBox>
        </Collapse>
      )}
    </Wrapper>
  );
};
